module.exports = {
  Monday: 'Segunda-feira',
  Tuesday: 'Terça-feira',
  Wednesday: 'Quarta-feira',
  Thursday: 'Quinta-feira',
  Friday: 'Sexta-feira',
  Saturday: 'Sábado',
  Sunday: 'Domingo',
  CollectSuccess: 'Pronto! \nPacote entregue',
  MerchantStoreSuccess: 'Pronto!\nPacote coletado',
  CustomerStoreSuccess: 'Pronto!\nPacote recebido',
  ReturnSuccess: 'Pronto! Pacote distribuído',
  Success: 'Success',
  Exp: 'Vencido',
  UnStored: 'Unstored',
  Stored: 'Recebido',
  ExpiredReturned: 'Distribuído',
  Returns: 'Para distribuir',
  Returned: 'Distribuído',
  Arriving: 'Previsto',
  Collected: 'Entregue',
  Created: 'Integrado',
  Cancelled: 'Cancelled',
  Store: 'Receber',
  Collect: 'Entregar',
  common: {
    Back: 'Voltar',
    Back2: 'Voltar para o início',
    locationName: '',
    Home: 'Início',
    Save: 'Salvar',
    Confirm: 'Confirmar',
    ScanNext: 'Escanear próximo',
    Cancel: 'Cancelar',
    reScan: 'Cancelar',
    ScanBarcode: 'Escanear código',
    ScanToStore: 'Escaneie para receber',
    ScanToReturn: 'Escaneie para distribuir',
    monthArr: new Array('Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'),
    weekArr: new Array('Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado', 'Domingo'),
    dayFormat: '',
    space: ' ',
    loadMore: 'Carregar mais...',
    finishLoading: 'Carregamento concluído',
    noMore: 'Não mais'
  },
  login: {
    LoginTitle: 'Acesse o LoggiPonto',
    Login: 'Entrar',
    Username: 'Usuário',
    Password: 'Senha'
  },
  bottom: {
    line: 'Suporte Loggi: ',
    support: 'Suporte Loggi'
  },
  index: {
    profile: 'Meu perfil',
    locationName: '',
    Arriving: 'Previsto',
    Stored: 'Coletado',
    Collected: 'Entregue',
    Returns: 'Para distribuir',
    Store: 'Receber',
    Collect: 'Entregar para \ncliente',
    Courier: 'Distribuir \ntransportadora',
    expired: 'Distribuir \nvencidos',
    OrderId: 'Código do pacote, ',
    PhoneNumber: 'telefone, ',
    NewLabelNumber: 'barras da nova etiqueta'
  },
  profile: {
    TodayLogs: 'Hoje',
    Total: 'Total',
    ThisMonth: 'Este mês',
    LocationID: 'Identificação do LoggiPonto',
    LocationName: 'Nome do LoggiPonto',
    Address: 'Endereço',
    ShopContact: 'Contato',
    Username: 'Usuário',
    RegisteredPhoneNumber: 'Telefone de cadastro',
    BusinessHours: 'Horário de funcionamento',
    Edit: 'Editar',
    Logout: 'Sair',
    Parcels: 'Pacotes',
    withLabel: 'com etiqueta',
    withoutLabel: 'sem etiqueta'
  },
  editProfile: {
    EditProfile: 'Editar perfil',
    LocationID: 'Identificação do LoggiPonto',
    LocationNameEnglish: 'Nome do LoggiPonto',
    LocationNameChinese: 'Location name (Chinese)',
    AddressEnglish: 'Endereço',
    AddressChinese: 'Address (Chinese)',
    Username: 'Usuário',
    RegisteredPhoneNnumber: 'Telefone de cadastro',
    BusinessHours: 'Horário de funcionamento',
    ShopContact: 'Contato',
    Monday: 'Segunda-feira',
    Tuesday: 'Terça-feira',
    Wednesday: 'Quarta-feira',
    Thursday: 'Quinta-feira',
    Friday: 'Sexta-feira',
    Saturday: 'Sábado',
    Sunday: 'Domingo',
    Rest: 'Fechado',
    AddMoreHours: 'Adicionar horário',
    OpenHours: 'Aberto 24 horas',
    ExceptionsOrHolidays: 'Exceções ou feriados',
    AddSpecialHours: 'Adicionar ou remover horário de funcionamento especial',
    Open: 'Abertura',
    Close: 'Fechamento',
    SelectSpecialDays: 'Selecionar dias especiais',
    OK: 'OK',
    Cancel: 'Cancelar'
  },
  selectCompany: {
    ReturnCourier: 'Distribuir para transportadora',
    ReturnExpired: 'Distribuir vencidos'
  },
  editRemark: {},
  expired: {
    Returns: 'Distribuir para transportadora',
    Expired: 'Distribuir vencidos'
  },
  barCode: {
    PleaseAim: 'Posicione o código de barras \nna marcação',
    PleaseAimBarcode: 'Aponte para o código de barras \nda mini-etiqueta',
    PleaseAimWithLabel: 'Posicione o código de barras ou QR code na marcação',
    PleaseAimWithoutLabel1: 'Posicione o código de barras ou QR code na marcação',
    PleaseAimWithoutLabel2: 'Posicione o código de barras ou QR code da mini etiqueta na marcação',
    manually: 'Digitar código',
    manuallyWITHOUT_LABEL: 'Digitar código de rastreio',
    manuallyWithoutLabelStep2: 'Digitar código da mini etiqueta',
    Loading: 'Carregando...',
    mismatch: 'Este pacote não corresponde ao código PIN',
    formatnomatch: 'Ops! Não conseguimos ler esse código. Tente escanear o código de barras ou o QR code novamente, ou se preferir, digite o código de barras manualmente.',
    noPermission: 'Não há permissão para aceder à câmera!',
    nofind: 'Não consegue encontrar câmera!',
    confirmMiniLabelText: 'Você deseja associar esta etiqueta ao pacote? \nVerifique os dados antes de confirmar:',
    withoutLabelStep1Text: 'Buscar pacote',
    withoutLabelStep2Text: 'Associar etiqueta',
    ScanMessageWithoutLabelStep1Text: 'Escaneie o QR Code \ndo cliente',
    ScanMessageWithoutLabelStep2Text: 'Escaneie o código da \nmini etiqueta'
  },
  qrCode: {
    PleaseAim: 'Posicione o QR code na marcação',
    manually: 'Digitar PIN'
  },
  enterBarCode: {
    EnterBarcode: 'Digitar código de \nbarras',
    EnterBarcodeWITHOUT_LABEL: 'Digitar código de\n rastreio',
    EnterBarcodeStore: 'Digitar código de barras\n da mini etiqueta',
    EnterName: 'Digite o nome do recebedor',
    EnterID: 'Digite o CPF do recebedor'
  },
  enterPIN: {
    EnterPIN: 'Digitar número do PIN',
    ScanApp: 'Bipar Código QR'
  },
  success: {
    Note: 'Notas (Opcional):\nExemplo: O pacote está na segunda prateleira',
    ScanParcel: 'Bipar localização do pacote',
    EditNote: 'Edit notes',
    CollectSuccess: 'Pronto! \nPacote entregue',
    StoreSuccess: 'Pronto!\nPacote recebido',
    ReturnSuccess: 'Return success',
    Success: 'Success',
    successID: 'ID do pacote',
    step1SuccessTitle: 'Pronto!',
    step1SuccessMsg: 'Pacote encontrado. \nEscaneie o \n código de barras \nda mini etiqueta.',
    step1ScanNext: 'Escanear novo código',
    newOrderNumber: 'Novo ID do pacote',
    withoutLabelStep2SuccessTitle: 'Pacote encontrado',
    withoutLabelStep2SuccessTitle2: 'Cole a mini etiqueta \nno pacote e escaneie \no código',
    step1ScanNextWithoutLabel: 'Escanear mini etiqueta'
  },
  details: {
    OrderDetails: 'Detalhes do pacote',
    OrderID: 'ID do pacote',
    NewLabelNumber: 'Barras da nova etiqueta',
    Logistics: 'Transportadora',
    Recipient: 'Recebedor',
    TimeStored: 'Coletado em',
    Notes: 'Notas',
    Edit: 'Editar',
    ScanBarcode: 'Escanear código',
    ScanToStore: 'Escaneie para receber',
    ScanToReturn: 'Escaneie para distribuir',
    TimeCollected: 'Time collected',
    EditNotes: 'Editar notas',
    ScanParcel: 'Bipar localização do pacote'
  },
  total: {
    Total: 'Total',
    Completed: 'Finalizado',
    InProgress: 'Em progresso'
  },
  todayLogs: {
    TodayLogs: 'Hoje'
  },
  month: {
    TimeStored: 'Recebido em',
    TimeCollected: 'Time collected'
  },
  thisMonth: {
    ThisMonth: 'Este mês'
  },
  searchResult: {
    CannotFind: 'Não encontramos este pacote',
    TimeStored: 'Recebido em',
    TimeCollected: 'Time collected',
    TimeReturned: 'Time returned',
    TimeRecreated: 'Time recreated',
    Recreated: 'Time recreated'
  },
  selectFlow: {
    Title: 'Que tipo de item\nvocê quer receber?',
    WithLabelTitle: 'Pacote com etiqueta',
    WithLabelSubTitle: 'pacote com etiqueta impressa\npelo cliente',
    WithoutLabelTitle: 'Pacote sem etiqueta',
    WithoutLabelSubTitle: 'cliente mostra o QR Code ou código \nde envio recebido no app ou e-mail'
  },
  labeledPackage: {
    returnSuccess: 'Pronto！Pacote recebido. ID do pacote: {{orderId}}'
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/br.js